import { validateScheduleEventAction } from "../../../../../../../api/kehrblatt/schedule-events"

import { confirmScheduleEventActionIssues } from "../../../../../../../_shared/_logic/confirm-schedule-event-action-issues"

export type RunScheduleEventActionWithValidationOptions<TDirect, TReplace = TDirect> = {
  validationRequest: ScheduleEventActionValidationRequest
  executeDirect: () => Promise<TDirect>
  executeReplace?: () => Promise<TReplace>
}

export type ScheduleEventActionExecutionResult<TDirect, TReplace = TDirect> =
  | {
      status: "completed"
      strategy: ScheduleEventActionExecutionStrategy
      value: TDirect | TReplace
    }
  | { status: "canceled" }

export const runScheduleEventActionWithValidation = async <TDirect, TReplace = TDirect>({
  validationRequest,
  executeDirect,
  executeReplace,
}: RunScheduleEventActionWithValidationOptions<TDirect, TReplace>): Promise<
  ScheduleEventActionExecutionResult<TDirect, TReplace>
> => {
  const validation = await validateScheduleEventAction(validationRequest)

  if (validation.issues.length) {
    const confirmed = await confirmScheduleEventActionIssues(validation.issues, {
      operation: validationRequest.operation,
      surface: validationRequest.surface,
      executionStrategy: validation.execution_strategy,
    })

    if (!confirmed) return { status: "canceled" }
  }

  if (validation.execution_strategy === "CANCEL_AND_CREATE") {
    if (!executeReplace) {
      throw new Error("Für diese Änderung muss ein Ersatztermin angelegt werden.")
    }

    return {
      status: "completed",
      strategy: validation.execution_strategy,
      value: await executeReplace(),
    }
  }

  return {
    status: "completed",
    strategy: validation.execution_strategy,
    value: await executeDirect(),
  }
}
